import { Flex } from '@chakra-ui/react'
import { Divider, Panel } from 'components'
import { useState } from 'react'
import { useBreakpoint, useTheme } from 'utils'
import { useEvent } from '../../../utils'
import EventBannerAnalyticsBar from './EventBannerAnalyticsBar'
import EventBannerConfigBar from './EventBannerConfigBar'
import EventBannerHeroImage from './EventBannerHeroImage'
import EventBannerTitleBar from './EventBannerTitleBar'
import ToggleEventBannerButton from './ToggleEventBannerButton'

export default function EventBanner() {
  const { theme } = useTheme()
  const { event } = useEvent()
  const breakPoint = useBreakpoint()
  const isMobile = breakPoint < 2
  const [expanded, setExpanded] = useState<boolean>(event?.sessionCount ? false : true)
  const unrestrained = expanded || isMobile

  return (
    <Panel
      {...(isMobile && { borderRadius: 'none' })}
    overflow="hidden"
      flexShrink={0}
      flexDirection="column"
      backdropFilter="none"
    >
      <Flex
        bg={theme == 'light' ? 'rgba(255, 255, 255, 0.44)' : ''}
        borderBottomWidth={theme == 'light' ? 'none' : '1px solid rgba(255, 255, 255, 0.15)'}
        flexDirection={{ base: 'column', lg: 'row' }}
        p={{ base: 0, lg: expanded ? 5 : 3 }}
      >
        <EventBannerHeroImage expanded={expanded} />

        <Flex
          direction="column"
          flex={1}
          justify="center"
          gap={5}
          py={expanded ? 6 : 3}
          px={{ base: 5, lg: 8 }}
        >
          <Flex width="100%" align="center" justify="space-between">
            <EventBannerTitleBar expanded={expanded} />
            {!unrestrained && (
              <Flex gap={5} align="center">
                {breakPoint > 3 && <EventBannerAnalyticsBar expanded={false} />}
                <ToggleEventBannerButton isExpanded={expanded} onClick={() => setExpanded(true)} />
              </Flex>
            )}
          </Flex>

          {expanded && (
            <>
              <Divider />
              <EventBannerConfigBar />
            </>
          )}
        </Flex>
      </Flex>

      {unrestrained && !!event?.sessionCount && (
        <Flex direction="row" w="100%" justify="space-between" align="center" px={5}>
          <EventBannerAnalyticsBar expanded={true} />
          {!isMobile && (
            <ToggleEventBannerButton isExpanded={expanded} onClick={() => setExpanded(false)} />
          )}
        </Flex>
      )}
    </Panel>
  )
}
